<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.233" height="19.745" viewBox="0 0 21.233 19.745">
    <g class="a" transform="translate(0.495 0.495)">
      <path class="b" d="M18.621,2.55,21.45,5.379,20.036,6.793,17.207,3.965Z" transform="translate(-1.207 -2.55)"/>
      <path class="b" d="M1.414,0,4.243,2.828,2.829,4.243,0,1.414Z" transform="translate(4.243) rotate(90)"/>
      <path class="b" d="M12.823,8.6h-2v4h2Z" transform="translate(-1.207 -2.55)"/>
      <path class="c"
            d="M5.186,18.814a9,9,0,1,0,0-12.728A9,9,0,0,0,5.186,18.814ZM6.6,17.4a7,7,0,1,0,0-9.9A7,7,0,0,0,6.6,17.4Z"
            transform="translate(-1.207 -2.55)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "StopwatchIcon"
}
</script>

<style scoped>
.a {
  isolation: isolate;
}

.b, .c {
  fill: #8ea2a8;
  stroke: #f5f5f5;
  stroke-width: 0.7px;
}

.c {
  fill-rule: evenodd;
}
</style>
